import Moment from 'moment';

//utils
import {
  syncCoveragesWithPresets,
  type deriveFormattedPolicyDetails,
} from '../utils/endorsement-workflow.utils';

//types
import type { CoverageDetailsProgress } from '../types/endorsement-workflow.types';
import type { ProductType } from '../../../../../types';
import { useGetPresets } from '../../../../agencies/quotes/PrimeX/customizeQuote/hooks/useGetPresets';
import CoverageSummaryLoadingSkeleton from './CoverageSummaryLoadingSkeleton';
import { CoverageSummary } from './CoverageSummaryResolver/CoverageSummary';

interface CoverageSummaryResolverProps {
  progressData: CoverageDetailsProgress['payload'];
  policyDetails: ReturnType<typeof deriveFormattedPolicyDetails>;
  endorsementStartDate: string | null | undefined;
}

export const CoverageSummaryResolver = (
  props: CoverageSummaryResolverProps
) => {
  const { data: presets, isLoading: isLoadingPresets } = useGetPresets({
    queryKey: ['mte-presets', props.policyDetails.id],
    accountData: props.policyDetails.firmographicData as any,
    productType: props.policyDetails.productType as ProductType,
    limit: props.policyDetails.aggregateLimit as unknown as number,
    effectiveDate: props.endorsementStartDate || Moment().format('YYYY-MM-DD'),
    agencyId: props.policyDetails.agencyId as string,
  });

  if (isLoadingPresets || !presets || !props.policyDetails.coverages) {
    return <CoverageSummaryLoadingSkeleton />;
  }

  const syncedProgressData = syncCoveragesWithPresets<
    CoverageSummaryResolverProps['progressData']
  >(presets?.coverageGroups, props.progressData);

  const syncedPolicyData = syncCoveragesWithPresets<
    CoverageSummaryResolverProps['policyDetails']
  >(presets?.coverageGroups, props.policyDetails);

  return (
    <CoverageSummary
      progressData={syncedProgressData}
      policyDetails={syncedPolicyData}
    />
  );
};
